<div *ngIf="!isLoading" supplystackTheme class="main-wrapper"
    [ngClass]="{'mobile-sidebar-present': mobileSidebarPresent}">
    <supplystack-sidebar-2 #sidebarDirective *ngIf="sidebarActive" [appIcon]="appIcon" [isOpen]="isSidebarOpened"
        [class.open]="isSidebarOpened === true" [loggedUserDetails]="loggedUser" (openEvent)="openSidebar()"
        (logoutEvent)="logout()" [hasHeader]="true" [typeOfHeader]="'generic_partner_portal' | translate" (creditsEvent)="credits()"
        (profileEvent)="profile()">
        <button class="sidebar-button-wrapper" *ngFor="let option of sidebarOptions"
            (click)="sidebarNavigate(option.link)">
            <div class="sidebar-button-wrapper-option" matTooltip="{{translate.instant(option.name)}}"
                [matTooltipPosition]="'right'" [matTooltipDisabled]="isSidebarOpened">
                <mat-icon>{{option.icon}}</mat-icon>
                <span>{{translate.instant(option.name)}}</span>
            </div>
        </button>
        <button class="sidebar-button-wrapper sidebar-mobile-button-wrapper" *ngFor="let option of sidebarOptions"
            (click)="sidebarMobileNavigate(option.link)">
            <div class="sidebar-button-wrapper-option" matTooltip="{{translate.instant(option.name)}}"
                [matTooltipPosition]="'right'" [matTooltipDisabled]="isSidebarOpened">
                <mat-icon>{{option.icon}}</mat-icon>
                <span>{{translate.instant(option.name)}}</span>
            </div>
        </button>
        <button class="sidebar-button-wrapper" [matMenuTriggerFor]="searchOrderMenu"
            matTooltip="{{translate.instant('generic_search_orders')}}" [matTooltipPosition]="'right'"
            [matTooltipDisabled]="isSidebarOpened" (click)="openOrderSearchMenu()">
            <div class="sidebar-button-wrapper-option">
                <mat-icon>search</mat-icon>
                <span>{{'generic_search_orders' | translate}}</span>
            </div>
        </button>
        <button class="sidebar-button-wrapper sidebar-search-input">
            <form [formGroup]="searchForm" (submit)="searchSidebarValue()" novalidate>
                <div class="sidebar-button-wrapper-option">
                    <mat-icon>search</mat-icon>
                    <input formControlName="search" type="text"
                        placeholder="{{translate.instant('generic_enter_tracking_nr')}}">
                </div>
            </form>
        </button>
    </supplystack-sidebar-2>
    <div class="action-wrapper" [ngClass]="{'sidebar-present': sidebarActive, 'sidebar-opened': sidebarOpened}">
        <div style="width: 100%; height: 64px;" *ngIf="loginTopbarActive || normalTopbarActive">
            <supplystack-topbar *ngIf="loginTopbarActive" [logo]="appLogo" (searchEvent)="searchEvent($event)"
                (registerEvent)="registerEvent()" (loginEvent)="loginEvent()" (logoEvent)="logoEvent()"
                [loginLabel]="translate.instant('generic_login')" [registerEnabled]="isRegisterActive"
                [registerLabel]="translate.instant('generic_register')">
            </supplystack-topbar>
            <mat-toolbar *ngIf="normalTopbarActive" class="normal-topbar">
                <mat-toolbar-row style="height: 64px;">
                    <button mat-icon-button *ngIf="!canNavigateBack()" class="dashboard-mobile-button"
                        (click)="mobileShowSidebar()">
                        <mat-icon>menu</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="canNavigateBack()" (click)="navigateBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <span *ngIf="!isSpecialTopbar" class="title" for="title">{{topbarNaming}}</span>
                    <div *ngIf="isSpecialTopbar" class="title">
                        <span
                            *ngIf="isSalesOrderMode && !getOrderTitle.sAirbillSeq">{{getOrderTitle.sSalesOrderCode}}</span>
                        <span
                            *ngIf="isMaterialOrderMode && !getOrderTitle.sAirbillSeq">{{getOrderTitle.sMatOrderCode}}</span>
                        <span *ngIf="!!getOrderTitle.sAirbillSeq">Airway Bill: {{getOrderTitle.sAirbillSeq}}</span>
                    </div>
                    <span class="example-spacer"></span>
                    <div *ngIf="isDashboard" class="dashboard-options">
                        <form class="search-order-form" [formGroup]="searchForm" (submit)="searchValue()" novalidate>
                            <div class="search-input">
                                <input type="text" formControlName="search" class="input-2-input"
                                   [ngClass]="{'input-invalid': search.touched && search.invalid}"
                                    placeholder="{{translate.instant('generic_enter_tracking_nr')}}">
                                <button mat-button type="submit" class="search-button">
                                    <mat-icon>search</mat-icon>
                                </button>
                            </div>
                        </form>
                        <button *ngIf="isOrderCreationEnabled" mat-button
                            class="theme-button add-order-dashboard-button" style="margin-left: 24px;"
                            (click)="addOrder()">
                            <mat-icon>add</mat-icon>&nbsp;
                            {{'generic_add_order' | translate}}
                        </button>
                        <button *ngIf="isOrderCreationEnabled" class="add-order-icon-button" mat-icon-button
                            (click)="addOrder()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <div *ngIf="isSpecialTopbar" class="status-pdf">
                        <span class="status-title">{{'generic_status' | translate}}</span>
                        <div class="status-chip" [ngStyle]="{'margin-right': isSalesOrderMode ? '16px' : '0px'}">
                            <div class="bullet"
                                [ngStyle]="{'background': isSalesOrderMode ? getOrderStatusColor(getOrderTitle.sStatus) : getOrderStatusColor(getOrderTitle.sFullMatOrderStatus)}">
                            </div>
                            &nbsp;{{
                            isSalesOrderMode
                            ? !!getOrderStatus(getOrderTitle.sStatus) ?
                            translate.instant(getOrderStatus(getOrderTitle.sStatus)) : ''
                            : !!getOrderStatus(getOrderTitle.sFullMatOrderStatus) ?
                            translate.instant(getOrderStatus(getOrderTitle.sFullMatOrderStatus)) : ''
                            }}
                        </div>
                        <button *ngIf="isSalesOrderMode" mat-button class="theme-button-inverted navigate-order-pdf"
                            (click)="navigatePdf()">
                            {{'generic_view_pdf' | translate}}
                        </button>
                    </div>
                    <div class="tooltip-slider" *ngIf="isOrderCreation">
                        <span>{{'generic_show_tooltips' | translate}}</span>
                        <mat-slide-toggle [checked]="tooltipEnabled" (toggleChange)="toggleTooltips()"></mat-slide-toggle>
                    </div>
                </mat-toolbar-row>
            </mat-toolbar>
        </div>
        <div id="scrolling-view" class="page-wrapper"
            [ngStyle]="{'height': (loginTopbarActive || normalTopbarActive) ? 'calc(100vh - 64px)' : '100vh'}">
            <router-outlet (activate)="onActivate()"></router-outlet>
        </div>
    </div>
</div>
<div *ngIf="isLoading" class="loading-wrapper">
    <supplystack-loading-view [msg]="'Loading'"></supplystack-loading-view>
</div>

<mat-menu #searchOrderMenu="matMenu" [overlapTrigger]="false" [xPosition]="'after'" [yPosition]="'above'">
    <supplystack-sidebar-search-value (updateFilter)="searchOrder($event)">
    </supplystack-sidebar-search-value>
</mat-menu>

<supplystack-cookie-banner></supplystack-cookie-banner>
